var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("dart-select", {
        staticClass: "lang-select",
        attrs: {
          options: _vm.supportedLanguages,
          labels: _vm.supportedLanguagesLabel,
          "lang-root": _vm.langRoot,
          darkTheme: _vm.darkTheme
        },
        on: { change: _vm.setLanguage },
        scopedSlots: _vm._u([
          {
            key: "option",
            fn: function(slotProps) {
              return [
                _c(
                  "span",
                  [
                    slotProps && slotProps.isSelected
                      ? _c("i8-icon", {
                          staticClass: "dart-select__option__icon",
                          attrs: { icon: "agree", colour: "white" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            }
          }
        ]),
        model: {
          value: _vm.selectedLang,
          callback: function($$v) {
            _vm.selectedLang = $$v
          },
          expression: "selectedLang"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-231f48de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-231f48de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./shared/components/LanguageSelect.vue
// module id = 2X0R
// module chunks = 0 1 2